import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);
export const formatAsLongDate = (date) => dayjs(date).format('dddd Do MMMM YYYY');
//# sourceMappingURL=format.js.map